
import { Link }
  from 'react-router-dom';

import Content
  from 'app/components/content/Content';
import RouteServers
  from 'app/components/navigation/RouteServers';


const Sidebar = () => {
  return (
    <aside className="page-sidebar">
      <div className="sidebar-header">
        <div className="logo">
          <Link to='/'>
            <img
              src="https://gbonline.com.br/_next/static/media/logo_default.0hp-skjrx5vm-.webp"
              alt="GB Online"
              className="logo-icon"
              style={{
                height: "32px", // altura da logo
                width: "auto",  // mantém proporção
                display: "block"
              }}
            />
          </Link>
        </div>
        <div className="title">
          <h1><Content id="header.title">PTT GB Online</Content></h1>
          <p>
            <a href="https://gbonline.com.br" target="_blank" rel="noopener noreferrer">
              www.gbonline.com.br
            </a>
          </p>
        </div>
      </div>
      <RouteServers />
    </aside>
  );
}

export default Sidebar;
